import { ReactElement } from "react";
import Head from "next/head";
import { MainLayout } from "@/containers/layout/NowLayout";
import PropertySearchPage from "@/components/landing-new/PropertySearch/PropertySearch";
import GotQuestions from "@/components/landing-new/PropertySearch/GotQuestions/GotQuestions";
import KnowYourBudget from "@/components/landing-new/PropertySearch/KnowYourBudget/KnowYourBudget";
import GotQuestionsAboutNeighbourhood from "@/components/properties/GotQuestionsAboutNeighbourhood/GotQuestionsAboutNeighbourhood";

import Image from "next/image";

const Properties = () => {
  return (
    <>
      <Head>
        <title>Homes available for rent to buy with Keyzy</title>
        <link rel="canonical" href="https://www.keyzy.com/properties" />
        <meta
          name="description" key="description"
          content="Discover rent-to-buy properties near you! Rent flats or houses now, buy later at a fixed price using your rent as your deposit."
        />
        <meta
          name="twitter:card"
          content="Discover rent-to-buy properties near you! Rent flats or houses now, buy later at a fixed price using your rent as your deposit."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta
          property="og:image"
          content="/properties/meta-og-keyzy-properties.png"
          key="ogimage"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta
          property="og:title"
          content="Homes available for rent to buy with Keyzy"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Discover rent-to-buy properties near you! Rent flats or houses now, buy later at a fixed price using your rent as your deposit."
          key="ogdesc"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://keyzy.com/" },
                { "@type": "ListItem", "position": 2, "name": "Properties", "item": "https://keyzy.com/properties" },
              ],
            }),
          }}
        />
      </Head>
      <PropertySearchPage />

      <div className="absolute hidden transform rotate-180 -left-10 -top-5 w-96 h-36 xl:inline-block">
        <Image
          src="/shared/shapes.svg"
          alt="shapes doodles"
          objectFit="contain"
          layout="fill"
          priority
        />
      </div>

      <GotQuestionsAboutNeighbourhood />

      <div className="relative h-full bg-white w-full overflow-hidden mb-9 md:mb-0">
        <div className="flex w-full left-0 right-0 m overflow-hidden bg-repeat-x lg:mt-7 h-24 md:h-52 xl:h-48 bg-[url('/intermediaries/city-outline-mobile.svg')]  md:bg-[url('/intermediaries/city-outline-tablet.svg')] xl:bg-[url('/intermediaries/city-outline-desktop.svg')]" />
      </div>
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2">
          <GotQuestions />
        </div>
        <div className="absolute hidden transform rotate-180 -left-10 -top-5 w-96 h-36 xl:inline-block">
          <Image
            src="/shared/shapes.svg"
            alt="shapes doodles"
            objectFit="contain"
            layout="fill"
            priority
          />
        </div>
        <div className="lg:w-1/2">
          <KnowYourBudget />
        </div>
      </div>
    </>
  );
};

Properties.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout theme="light">{page}</MainLayout>;
};

export default Properties;
